import React from 'react';

import type { SearchBoxProps } from '../../../types';
import { Input } from '../../common/Input';

/**
 * SearchBox Component - Device search interface
 *
 * Provides a fixed-position search input at the bottom of the screen
 * for filtering devices by text, title, or ID. Automatically clears
 * the search after 60 seconds of inactivity (UX feature).
 *
 * @example
 * <SearchBox
 *   searchQuery={searchQuery}
 *   onSearchChange={setSearchQuery}
 *   spaceForFilters={showFilters}
 * />
 */
export const SearchBox: React.FC<SearchBoxProps> = ({
  searchQuery,
  onSearchChange,
  spaceForFilters = false,
}) => {
  const containerStyle: React.CSSProperties = {
    position: 'fixed',
    left: 0,
    width: '100vw',
    height: spaceForFilters ? '13vmin' : '6vmin',
    bottom: 0,
    background: '#fff8', // Semi-transparent white background
    zIndex: 2000, // Ensure it stays on top and is clickable
  };

  const inputContainerStyle: React.CSSProperties = {
    position: 'fixed',
    left: '33vw',
    width: '35vw',
    bottom: '0vh',
  };

  return (
    <div style={containerStyle}>
      <div style={inputContainerStyle}>
        <Input placeholder="Search devices..." value={searchQuery} onChange={onSearchChange} />
      </div>
    </div>
  );
};

export default SearchBox;
